import script from "./ProfileMenu.vue?vue&type=script&lang=ts&setup=true"
export * from "./ProfileMenu.vue?vue&type=script&lang=ts&setup=true"

import "./ProfileMenu.vue?vue&type=style&index=0&id=6d11daa6&lang=scss&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-6d11daa6"]])

export default __exports__